<template>
  <b-card-actions action-collapse title="Liste des fournisseur">
    <div class="custom-search">
      <!-- advance search input -->
      <div class="custom-search d-flex justify-content-end">
        <b-form-group>
          <div class="d-flex align-items-center">
            <label class="mr-1">Recherche</label>
            <b-form-input
              placeholder="Recherche"
              type="text"
              class="d-inline-block"
              @input="advanceSearch"
            />
            <b-button
              variant="gradient-danger"
              class="btn-icon btn-delete-all"
              @click="deleteAllSupplier()"
            >
              <feather-icon icon="TrashIcon" />
            </b-button>
          </div>
        </b-form-group>
      </div>
    </div>

    <!-- table -->
    <!-- :rtl="direction" -->
    <vue-good-table
      ref="table-supplier"
      :columns="columns"
      :rows="rows"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm,
      }"
      :select-options="{
        enabled: true,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, // disable the select info panel on top
        selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
      }"
      :pagination-options="{
        enabled: true,
        perPage: pageLength,
      }"
      theme="my-theme"
    >
      <template slot="table-row" slot-scope="props" class="table-added-element">
        <span v-if="props.column.field === 'action'">
          <span>
            <b-dropdown
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template v-slot:button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="text-body align-middle mr-25"
                />
              </template>
              <b-dropdown-item>
                <feather-icon icon="EyeIcon" class="mr-50" />
                <span><router-link :to="`/shop/quote/quote?supplier=${props.row._id}`" >Consulter devis</router-link></span>
              </b-dropdown-item>
              <b-dropdown-item>
                <feather-icon icon="EyeIcon" class="mr-50" />
                <span><router-link :to="`/shop/command?supplier=${props.row._id}`" >Consulter commande</router-link></span>
              </b-dropdown-item>
              <b-dropdown-item>
                <feather-icon icon="EyeIcon" class="mr-50" />
                <span><router-link :to="`/shop/invoice/invoice?supplier=${props.row._id}`" >Consulter facture</router-link></span>
              </b-dropdown-item>
              <b-dropdown-item @click="UpdateSupplier(props.row._id)">
                <feather-icon icon="Edit2Icon" class="mr-50" />
                <span>Modifier</span>
              </b-dropdown-item>
              <b-dropdown-item @click="DeleteSupplier(props.row._id)">
                <feather-icon icon="TrashIcon" class="mr-50" />
                <span>Supprimer</span>
              </b-dropdown-item>
            </b-dropdown>
          </span>
        </span>
        <span v-if="props.column.field === 'telNumbers'">
          <ul v-for="(number, index) in props.row.telNumbers" :key="index">
            <li v-if="number!=''">{{ number }}</li>
          </ul>
        </span>

        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>

      <!-- pagination -->
      <template slot="pagination-bottom" slot-scope="props">
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap"> Afficher 1 à </span>
            <b-form-select
              v-model="pageLength"
              :options="['3', '5', '10']"
              class="mx-1"
              @input="
                (value) => props.perPageChanged({ currentPerPage: value })
              "
            />
            <span class="text-nowrap"> sur {{ props.total }} résultats </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value) => props.pageChanged({ currentPage: value })"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
  </b-card-actions>
</template>

<script>
import VueBarcode from "vue-barcode";
import BCardActions from "@core/components/b-card-actions/BCardActions.vue";
import {
  BAvatar,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BButton,
  BRow,
  BCol,
  BImg,
  BDropdown,
  BDropdownItem,
  BTooltip,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { VueGoodTable } from "vue-good-table";
import store from "@/store/index";
import axios from "axios";
import Ripple from "vue-ripple-directive";

export default {
  directives: {
    Ripple,
  },
  components: {
    BDropdown,
    BDropdownItem,
    BTooltip,
    VueBarcode,
    BImg,
    BButton,
    BCardActions,
    VueGoodTable,
    BAvatar,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BRow,
    BCol,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  data() {
    return {
      pageLength: 5,
      dir: false,
      columns: [
         {
          label: "Action",
          field: "action",
          sortable: false,
        },
        {
          label: "Nom",
          field: "firstName",
          filterOptions: {
            enabled: true,
            placeholder: "Nom",
          },
        },
        {
          label: "Prénom",
          field: "lastName",
          filterOptions: {
            enabled: true,
            placeholder: "Prénom",
          },
        },
        {
          label: "Email",
          field: "email",
          filterOptions: {
            enabled: true,
            placeholder: "Email",
          },
        },
        {
          label: "City",
          field: "city",
          filterOptions: {
            enabled: true,
            placeholder: "Ville",
          },
        },
        {
          label: "Adresse",
          field: "address",
          filterOptions: {
            enabled: true,
            placeholder: "Adresse",
          },
        },

        {
          label: "Code postal",
          field: "postalCode",
          filterOptions: {
            enabled: true,
            placeholder: "Code postal",
          },
        },
        {
          label: "Numéro de téléphone",
          field: "telNumbers",
          filterOptions: {
            enabled: true,
            placeholder: "Numéro de téléphone",
          },
        },
        {
          label: "Date d'insertion",
          field: "createdAt",
          filterOptions: {
            enabled: true,
            placeholder: "Date d'insertion",
          },
          formatFn: this.dateFormat,
        },
        {
          label: "Agent de saisie",
          field: "createdBy",
          filterOptions: {
            enabled: true,
            placeholder: "Agent de saisie",
          },
          formatFn: this.nameFormat,
        },
        {
          label: "Date de modification",
          field: "updatedAt",
          filterOptions: {
            enabled: true,
            placeholder: "Date de modification",
          },
          formatFn: this.dateFormat,
        },

        // {
        //   label: "Image",
        //   field: "image",
        //   sortable: false,
        //   // html: true,
        // },
       
      ],
      rows: [],
      searchTerm: "",
    };
  },
  async created() {
    await this.getAllDataSupplier();
  },
  methods: {
    async getAllDataSupplier() {
      const response = await axios.get(
        "https://management-projects.herokuapp.com/api/suppliers"
      );
      console.log(response);
      this.rows = response.data;
    },
        deleteAllSupplier() {
      var deleteIds = [];
      this.$refs["table-supplier"].selectedRows.forEach((element) => {
        deleteIds.push(element._id);
      });
      console.log(deleteIds, this.$refs["table-supplier"].selectedRows);
      axios
        .delete(
          `https://management-projects.herokuapp.com/api/suppliers?ids=${deleteIds.join(
            ","
          )}&deletedBy=${JSON.parse(localStorage.getItem("userData"))._id}`
        )
        .then((response) => {
          this.getAllDataSupplier();
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `Fournisseur bien supprimé`,
              icon: "UserIcon",
              variant: "success",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `Erreur lors de la suppression`,
              icon: "UserIcon",
              variant: "danger",
            },
          });
          this.errorMessage = error.message;
          console.log(this.errorMessage);
        });
    },
    DeleteSupplier(id) {
      this.$swal({
        title: "vous voulez vraiment supprimer ce fournisseur ?",
        text: "Vous ne pourrez pas annuler cela!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Confirmer !",
        cancelButtonText: "Annuler !",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          var payload = {
            deletedBy: JSON.parse(localStorage.getItem("userData"))._id,
          };
          axios
            .delete(
              `https://management-projects.herokuapp.com/api/suppliers?ids=${id}&deletedBy=${
                JSON.parse(localStorage.getItem("userData"))._id
              }`
            )
            .then((response) => {
              this.getAllDataSupplier();
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: `fournisseur bien supprimé`,
                  icon: "UserIcon",
                  variant: "success",
                },
              });
            })
            .catch((error) => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: `Erreur lors de la suppression`,
                  icon: "UserIcon",
                  variant: "danger",
                },
              });
              this.errorMessage = error.message;
              console.log(this.errorMessage);
            });
        } else if (result.dismiss === "cancel") {
          this.$swal({
            title: "Action annulée",
            icon: "error",
            confirmButtonText: "Fermer !",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      });
    },
    UpdateSupplier(id) {
      var routerLink = "/supplier/edit-supplier?id=" + id;
      this.$router.replace(routerLink);
    },
    advanceSearch(val) {
      this.searchTerm = val;
    },
    // imgFormat: function (value) {
    //   if (value) {
    //     return (
    //       "https://res.cloudinary.com/dmdd546ps/image/upload/v1615691410/" +
    //       value
    //     );
    //   }
    // },
    //date format
    dateFormat: function (value) {
      return new Date(value).toLocaleString();
    },
    // name agent de saisie
    nameFormat: function (value) {
      return value.firstName + " " + value.lastName;
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-autosuggest.scss";
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
<style>
.btn-action-table button {
  margin-left: 10px;
  margin-top: 5px;
}
.btn-action-table {
  display: flex;
}
.btn-delete-all {
  margin-left: 3%;
}
</style>
